<template>
  <div class="delivery-fee-config-container">
    <div class="search-wrapper">
      <div class="search-title">送货手续费配置筛选</div>
      <div class="search-content">
        <el-input v-model="searchForm.communityId" placeholder="请输入小区ID" class="search-item" clearable @keyup.enter.native="handleSearch" />
        <el-input v-model="searchForm.storeId" placeholder="请输入店铺ID（-1为物业级）" class="search-item" clearable @keyup.enter.native="handleSearch" />
        <el-button type="primary" @click="handleSearch">查询</el-button>
        <el-button @click="handleReset">重置</el-button>
      </div>
    </div>

    <div class="list-wrapper">
      <div class="list-header">
        <div class="list-title">送货手续费配置管理</div>
        <el-button type="primary" @click="handleAdd">新增配置</el-button>
      </div>

      <el-table v-loading="loading" :data="tableData" border style="width: 100%">
        <el-table-column prop="configId" label="配置ID" min-width="180" show-overflow-tooltip />
        <el-table-column prop="communityId" label="小区ID" min-width="130" />
        <el-table-column prop="storeId" label="店铺ID" min-width="130" />
        <el-table-column prop="serviceFee" label="手续费(元)" min-width="120" />
        <el-table-column prop="remark" label="备注" min-width="220" show-overflow-tooltip />
        <el-table-column prop="createTime" label="创建时间" min-width="170" show-overflow-tooltip />
        <el-table-column label="层级" min-width="120">
          <template slot-scope="scope">
            <el-tag :type="scope.row.communityId === '-1' ? 'info' : (scope.row.storeId === '-1' ? 'warning' : 'success')">
              {{ levelLabel(scope.row) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="handleEdit(scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        :current-page.sync="page.current"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="page.size"
        :total="page.total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange" />
    </div>

    <el-dialog :title="dialogMode === 'add' ? '新增手续费配置' : '编辑手续费配置'" :visible.sync="dialogVisible" width="520px">
      <el-form :model="dialogForm" label-width="110px">
        <el-form-item label="小区ID">
          <el-input v-model="dialogForm.communityId" :disabled="dialogMode === 'edit'" placeholder="-1 表示全局默认" />
        </el-form-item>
        <el-form-item label="店铺ID">
          <el-input v-model="dialogForm.storeId" :disabled="dialogMode === 'edit'" placeholder="-1 表示物业级" />
        </el-form-item>
        <el-form-item label="手续费(元)">
          <el-input v-model="dialogForm.serviceFee" placeholder="如 2.00" />
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="dialogForm.remark" type="textarea" :rows="3" placeholder="选填" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getDeliveryFeeConfigList, addDeliveryFeeConfig, updateDeliveryFeeConfig } from '@/api/dev/deliveryFeeConfigApi'

export default {
  name: 'DeliveryFeeConfigManageList',
  data() {
    return {
      loading: false,
      searchForm: {
        communityId: '',
        storeId: ''
      },
      tableData: [],
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      dialogVisible: false,
      dialogMode: 'add',
      dialogForm: {
        configId: '',
        communityId: '',
        storeId: '-1',
        serviceFee: '',
        remark: ''
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    async getList() {
      this.loading = true
      try {
        const res = await getDeliveryFeeConfigList({
          page: this.page.current,
          row: this.page.size,
          communityId: this.searchForm.communityId,
          storeId: this.searchForm.storeId
        })
        this.tableData = res.data || []
        this.page.total = res.total || 0
      } catch (error) {
        this.$message.error(error.message || '加载手续费配置失败')
      } finally {
        this.loading = false
      }
    },
    handleSearch() {
      this.page.current = 1
      this.getList()
    },
    handleReset() {
      this.searchForm = {
        communityId: '',
        storeId: ''
      }
      this.page.current = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.page.size = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.page.current = val
      this.getList()
    },
    handleAdd() {
      this.dialogMode = 'add'
      this.dialogForm = {
        configId: '',
        communityId: '',
        storeId: '-1',
        serviceFee: '',
        remark: ''
      }
      this.dialogVisible = true
    },
    handleEdit(row) {
      this.dialogMode = 'edit'
      this.dialogForm = {
        configId: row.configId,
        communityId: row.communityId,
        storeId: row.storeId,
        serviceFee: row.serviceFee,
        remark: row.remark || ''
      }
      this.dialogVisible = true
    },
    async handleSubmit() {
      if (!this.dialogForm.communityId) {
        this.$message.warning('请填写小区ID')
        return
      }
      if (!this.dialogForm.storeId) {
        this.$message.warning('请填写店铺ID，物业级请填 -1')
        return
      }
      if (!this.dialogForm.serviceFee) {
        this.$message.warning('请填写手续费')
        return
      }

      try {
        if (this.dialogMode === 'add') {
          await addDeliveryFeeConfig(this.dialogForm)
          this.$message.success('新增成功')
        } else {
          await updateDeliveryFeeConfig({
            configId: this.dialogForm.configId,
            serviceFee: this.dialogForm.serviceFee,
            remark: this.dialogForm.remark
          })
          this.$message.success('更新成功')
        }
        this.dialogVisible = false
        this.getList()
      } catch (error) {
        this.$message.error(error.message || '提交失败')
      }
    },
    levelLabel(row) {
      if (!row) {
        return '未知'
      }
      if (row.communityId === '-1') {
        return '全局默认'
      }
      if (row.storeId === '-1') {
        return '物业级'
      }
      return '店铺级'
    }
  }
}
</script>

<style lang="scss" scoped>
.delivery-fee-config-container {
  padding: 15px;
  background-color: #f0f2f5;
}

.search-wrapper,
.list-wrapper {
  background-color: #fff;
  padding: 20px;
  border-radius: 4px;
}

.search-wrapper {
  margin-bottom: 20px;
}

.search-title,
.list-title {
  font-size: 16px;
  font-weight: bold;
  color: #333;
}

.search-content {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
  margin-top: 20px;
}

.search-item {
  width: 240px;
}

.list-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.el-pagination {
  margin-top: 20px;
  text-align: right;
}
</style>
